import * as React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import '../styles/Modal.scss'
import StylerImage2 from '../assets/imgs/stylers-images/styler-image-2.png'
import UploadImageIconWhite from '../assets/imgs/upload-images-icon-white.svg'
import EditPhotosPlayIcon from '../assets/imgs/edit-photos-play-icon.svg'
import DeleteIcon from '@mui/icons-material/Delete'
import { saveOrUpdateDataById } from '../apis/generalApis'
import Swal from 'sweetalert2'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  //   width: 400,
  outline: 'none',
  maxHeight: '90vh',
  overflow: 'auto',
  background:
    'transparent linear-gradient(180deg, #01CED1 0%, #14B1E4 51%, #2992FB 100%) 0% 0% no-repeat padding-box',
  // border: "2px solid #fff",
  boxShadow: '0px 5px 20px #00000040',
  p: 3,
  borderRadius: '16px',
  textAlign: 'center',
}

const EditPhotosModal = ({
  handleEditPhotosModal,
  openEditPhotosModal,
  userPortfolio = [],
  getPortfolioImages,
  isLoggedInUser = true,
}) => {
  const user = JSON.parse(localStorage.getItem('user'))
  const handleImageUpload = async (e) => {
    if (!e.target.files[0]) return
    let formData = new FormData()
    formData.append('user_id', user?.id)
    formData.append('attachment', e.target.files[0])
    let result = await saveOrUpdateDataById('add-portfolio', formData)
    if (result?.success === true && result?.data) {
      handleEditPhotosModal(false)
      Swal.fire({
        icon: 'success',
        title: 'Portfolio image added successfully!',
        confirmButtonColor: '#2597F6',
        timer: 3000,
      })
      getPortfolioImages()
    }
  }

  const deletePortfolioImage = async (id) => {
    let formData = new FormData()
    formData.append('user_id', user?.id)
    formData.append('portfolio_id', id)
    let result = await saveOrUpdateDataById('delete-portfolio', formData)
    if (result?.success === true) {
      handleEditPhotosModal(false)
      Swal.fire({
        icon: 'success',
        title: 'Portfolio image deleted successfully!',
        confirmButtonColor: '#2597F6',
        timer: 3000,
      })
      getPortfolioImages()
    }
  }

  return (
    <>
      <Modal
        open={openEditPhotosModal}
        onClose={() => handleEditPhotosModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="text-center">
            <h3 className="service-modal service-modal-title mb-3 text-black">
              Edit Photos
            </h3>
            <div className="row">
              {isLoggedInUser && (
                <div className="col-12 col-sm-6 col-md-3 p-1">
                  <div className="h-100 upload-image-videos-wrapper">
                    <label className="position-relative" htmlFor="image-input">
                      <img
                        src={UploadImageIconWhite}
                        alt="Upload Images Icon"
                        className="mb-2 pointer"
                        height={43}
                      />
                      <input
                        id="image-input"
                        type="file"
                        accept="image/*"
                        style={{
                          display: 'none',
                        }}
                        className="pointer"
                        onChange={handleImageUpload}
                      />
                    </label>
                    <p className="fs-16 text-white">
                      Upload Photos <br /> or Videos
                    </p>
                  </div>
                </div>
              )}
              {/* <div className="col-12 col-sm-6 col-md-3 p-0 position-relative">
                <img src={EditPhotosPlayIcon} className="play-button" alt="" />
                <img src={StylerImage2} alt="" className="w-100 h-100" />
              </div> */}
              {userPortfolio &&
                userPortfolio?.length > 0 &&
                userPortfolio?.map((item, index) => (
                  <div
                    className="col-12 col-sm-6 col-md-3 p-0 position-relative portfolio-image-wrapper"
                    key={item.id}
                  >
                    <img
                      src={item.attachment}
                      alt=""
                      className="w-100 h-100"
                      style={{ borderRadius: '16px', objectFit: 'cover' }}
                    />
                    <DeleteIcon
                      sx={{ color: '#fff', top: '2%', right: '2%' }}
                      className="position-absolute delete-icon pointer"
                      onClick={() => deletePortfolioImage(item.id)}
                    />
                  </div>
                ))}
            </div>
          </div>
        </Box>
      </Modal>
    </>
  )
}

export default EditPhotosModal
